import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm$order;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c(VToolbar, {
    attrs: {
      color: _vm.options.color,
      dense: "",
      flat: ""
    }
  }, [_c(VToolbarTitle, {
    staticClass: "white--text"
  }, [_vm._v("Correct payment data")])], 1), _c(VForm, {
    staticClass: "content",
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c(VCardText, {
    staticClass: "pb-0"
  }, [_vm._v("Please select a state to update the payment status.")]), _c(VSelect, {
    staticClass: "v-text-field-no-label required",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: "Payment state",
      items: _vm.paymentStates,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "auto",
      rules: [_vm.rules.mustNotBeEmpty]
    },
    model: {
      value: _vm.selectedStatus,
      callback: function callback($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  }), _c(VSelect, {
    staticClass: "v-text-field-no-label",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: "Payment method",
      "item-text": "name",
      "item-value": "id",
      items: _vm.paymentTypes,
      "hide-details": "auto"
    },
    model: {
      value: _vm.paymentType,
      callback: function callback($$v) {
        _vm.paymentType = $$v;
      },
      expression: "paymentType"
    }
  }), _vm.selectedStatus === _vm.paymentState.SUCCEEDED ? _c("div", [_c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "v-text-field-no-label required",
          attrs: {
            type: "date",
            label: "Payment date",
            "hide-details": "auto",
            required: "",
            rules: [_vm.rules.mustNotBeEmpty],
            disabled: _vm.validating
          },
          model: {
            value: _vm.paymentDate,
            callback: function callback($$v) {
              _vm.paymentDate = $$v;
            },
            expression: "paymentDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }], null, false, 177599174),
    model: {
      value: _vm.dateMenu,
      callback: function callback($$v) {
        _vm.dateMenu = $$v;
      },
      expression: "dateMenu"
    }
  }, [_c(VDatePicker, {
    on: {
      input: function input($event) {
        _vm.dateMenu = false;
      }
    },
    model: {
      value: _vm.paymentDate,
      callback: function callback($$v) {
        _vm.paymentDate = $$v;
      },
      expression: "paymentDate"
    }
  })], 1)], 1) : _vm._e(), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "text",
      label: "Payment reference",
      "hide-details": "auto",
      disabled: _vm.validating
    },
    model: {
      value: _vm.paymentReference,
      callback: function callback($$v) {
        _vm.paymentReference = $$v;
      },
      expression: "paymentReference"
    }
  }), _c("div", {
    staticClass: "tip"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm.selectedStatus === _vm.paymentState.SUCCEEDED ? [_vm._v(" To correct the amount, you must choose "), _c("strong", [_vm._v("In review")]), _vm._v(" and edit payment again. ")] : [_vm._v(" If you choose "), _c("strong", [_vm._v("Succeeded")]), _vm._v(" make sure that the payment has been made. ")]], 2)], 1), _c(VCardActions, {
    staticClass: "flex flex-column items-end"
  }, [((_vm$order = _vm.order) === null || _vm$order === void 0 ? void 0 : _vm$order.isPreventInvoice) === true && _vm.selectedStatus === _vm.paymentState.SUCCEEDED ? _c("div", {
    staticClass: "flex items-baseline justify-end lh-1 text-smaller"
  }, [_c(VCheckbox, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "Attach this payment to all existing\n        accountancy reconciliations on this order",
      "hide-details": "auto"
    },
    model: {
      value: _vm.isAttachPaymentToAccRecs,
      callback: function callback($$v) {
        _vm.isAttachPaymentToAccRecs = $$v;
      },
      expression: "isAttachPaymentToAccRecs"
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      text: "",
      disabled: _vm.validating
    },
    nativeOn: {
      click: function click($event) {
        return _vm.internalCancel.apply(null, arguments);
      }
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.validating,
      disabled: _vm.timeLeft > 0 && !_vm.validating || !_vm.isValid
    },
    nativeOn: {
      click: function click($event) {
        return _vm.agree.apply(null, arguments);
      }
    }
  }, [_vm._v(" Confirm " + _vm._s(_vm.timeLeft > 0 ? "".concat(_vm.timeLeft, "s") : "") + " ")])], 1)])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };